export default __webpack_public_path__ + "static/media/base-2-min.15b6f893.jpg";